import {defineMessages} from 'react-intl';

export default defineMessages({
	emailPlaceholder: {
		id: 'pdp.notifyMe.form.email.placeholder',
		defaultMessage: 'Your email address'
	},
	emailLabel: {
		id: 'pdp.notifyMe.form.email.label',
		defaultMessage: 'Email'
	},
	emailRequiredError: {
		id: 'pdp.notifyMe.form.email.requiredError',
		defaultMessage: 'Email is required'
	},
	emailInvalidError: {
		id: 'pdp.notifyMe.form.email.invalidError',
		defaultMessage: 'Invalid email format'
	},
	submitBtnText: {
		id: 'pdp.notifyMe.form.button',
		defaultMessage: 'Submit'
	},
	newsletter: {
		id: 'pdp.notifyMe.form.newsletter',
		defaultMessage: 'Register to our Newsletter',
	}
});